import React, { useState, useEffect, useRef } from 'react';
import { cn } from '../../utils/cn';
import Icon from '../AppIcon';

const DropdownMenu = ({ trigger, children, align = 'right', className }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen]);

  const alignClasses = {
    right: 'right-0',
    left: 'left-0',
    center: 'left-1/2 -translate-x-1/2',
  };

  return (
    <div className={cn('relative', className)}>
      <div
        ref={triggerRef}
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer"
      >
        {trigger}
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className={cn(
            'absolute top-full mt-2 z-50 min-w-[200px]',
            'bg-card border border-border rounded-lg shadow-lg',
            'py-2',
            alignClasses[align]
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export const DropdownMenuItem = ({ 
  children, 
  onClick, 
  icon, 
  className,
  variant = 'default',
  ...props 
}) => {
  const variantClasses = {
    default: 'text-foreground hover:bg-muted',
    destructive: 'text-error hover:bg-error/10',
  };

  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full flex items-center gap-3 px-4 py-2.5 text-sm font-medium',
        'transition-smooth text-left',
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {icon && <Icon name={icon} size={18} />}
      <span className="flex-1">{children}</span>
    </button>
  );
};

export const DropdownMenuSeparator = () => {
  return <div className="h-px bg-border my-2" />;
};

export default DropdownMenu;

